import React from 'react';

const LivePreview = ({ composedLayers, soloLayer, onToggleSolo, hoveredVariant }) => {
  const getLayerOpacity = (layerKey) => {
    if (soloLayer && soloLayer !== layerKey) return 0.3;
    return 1;
  };

  const getLayerImage = (layerKey) => {
    const layer = composedLayers[layerKey];
    if (!layer) return null;
    
    // If hovering over a variant, show it in preview
    if (hoveredVariant && hoveredVariant.layerKey === layerKey) {
      return hoveredVariant.src;
    }
    
    // Otherwise show the selected variant or first variant
    return layer.selectedVariant || layer.firstVariant;
  };

  return (
    <div className="live-preview">
      <div className="live-preview-header">
        <h3 className="live-preview-title">Live Preview</h3>
        <button
          className={`solo-toggle ${soloLayer ? 'active' : ''}`}
          onClick={onToggleSolo}
        >
          {soloLayer ? '👁️ Solo Mode' : '👁️ Solo Mode'}
        </button>
      </div>
      
      <div className="preview-container">
        <div className="preview-canvas">
          {Object.keys(composedLayers).map(layerKey => {
            const imageSrc = getLayerImage(layerKey);
            if (!imageSrc) return null;
            
            return (
              <img
                key={layerKey}
                src={imageSrc}
                alt={`${layerKey} layer`}
                className="preview-layer"
                style={{
                  opacity: getLayerOpacity(layerKey),
                  zIndex: getLayerZIndex(layerKey)
                }}
              />
            );
          })}
        </div>
        
        {!soloLayer && (
          <div className="preview-help">
            <p>Hover over variants to see live preview</p>
            <p>Click Solo to focus on one layer</p>
          </div>
        )}
        
        {soloLayer && (
          <div className="solo-info">
            <p>Showing only <strong>{soloLayer}</strong> layer</p>
            <p>Click Solo again to show all layers</p>
          </div>
        )}
      </div>
    </div>
  );
};

// Helper function to determine z-index for proper layering
const getLayerZIndex = (layerKey) => {
  const layerOrder = {
    back: 1,
    neck: 2,
    noses: 3,
    mouth: 4,
    eyes: 5,
    hairs: 6
  };
  return layerOrder[layerKey] || 1;
};

export default LivePreview;
